import { useState } from "react";
import { LogIn, Loader2 } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "تعذر تسجيل الدخول، تحقق من البيانات");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5" dir="rtl">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-coal/70 p-9">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <h1 className="mb-7 text-center text-xl font-bold text-white">لوحة تحكم ميرو</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-2 block text-sm font-bold text-zinc-200">البريد الإلكتروني</label>
            <input type="email" className="field" dir="ltr" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email-input" />
          </div>
          <div>
            <label className="mb-2 block text-sm font-bold text-zinc-200">كلمة المرور</label>
            <input type="password" className="field" dir="ltr" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password-input" />
          </div>
          {error && <p className="rounded-xl border border-[#EF4444]/40 bg-[#EF4444]/10 p-3 text-sm text-[#f87171]" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} className="btn-gold w-full !py-3.5" data-testid="admin-login-submit">
            {busy ? <Loader2 size={18} className="animate-spin" /> : <LogIn size={18} />} تسجيل الدخول
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-dim">هذه اللوحة مخصصة لإدارة ميرو فقط</p>
      </div>
    </div>
  );
}

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd);
  return data.url;
}
